import { AcmeIntegration } from "common/types/catalog-types";
import { ComplianceInformation } from "common/types/catalogical-type";
import { FeedbackStats } from "lib/services/catalogical-models";

export enum ItemTypes {
  HARDWARE = "hardware",
  SOFTWARE = "software",
}

export enum ItemSubtypes {
  LOCAL = "local",
  CLOUD = "cloud",
  HYBRID = "hybrid",
}

/**
 * Generic interface to represent the details of an item regarding of the catalog.
 * Used to render the Product details page.
 */
export interface ItemDetails {
  taxonomyId: string;
  name: string;
  description: string;
  shortDescription: string;
  status: string;
  logoUrl: string;
  publisher: string;
  etaDays: number;
  os: string[];
  categories: string[];
  priceAmount: number;
  priceCurrency: string;
  hasStock: boolean;
  orderWorkflow?: string;
  orderRedirectUrl?: string;
  externalButtonText?: string;
  moreDetailsUrl?: string;
  parentName?: string;
  parentTxId?: string;
  requiresLicenseCapValidation?: boolean;
  applinkProductName?: string;
  applinkInstanceName?: string;
  isReturnable?: boolean;
  subtype?: ItemSubtypes;
  acme?: AcmeIntegration;
  isAccessible?: boolean;
  version?: string;
  dataClassification?: string;
  securityStatus?: string;
  itptClassification?: string;
  feedback?: FeedbackStats;
  autoGenFormattedDescription?: string;
  productDownloadUrl?: string;
  complianceInformation?: ComplianceInformation;
  wikiUrl?: string;
}

export interface IItemVersion {
  taxonomyId: string;
  name: string;
  displayText: string;
  status: string;
  amount: number;
  currency: string;
  logoUrl?: string;
  applinkProductName?: string;
  applinkInstanceName?: string;
  isReturnable?: boolean;
  acme?: AcmeIntegration;
  orderRedirectUrl?: string;
  orderWorkflow?: string;
  requiresLicenseCapValidation?: boolean;
  feedback?: FeedbackStats;
  autoGenFormattedDescription?: string;
  productDownloadUrl?: string;
}
